import axios from './axios';

import auth from '../resources/Auth';

export default {
  all: async () => {
    let url = `${process.env.REACT_APP_API_URL}/eventReservation`;
    let token = localStorage.getItem('auth');

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  saveReservation: async (body) => {
    let url = `${process.env.REACT_APP_API_URL}/eventReservation/store/${body.service_id}`;
    let token = localStorage.getItem('auth');

    return await axios.post(
      url,
      { ...body },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
  },

  remove: async (id) => {
    let url = `${process.env.REACT_APP_API_URL}/eventReservation/remove/${id}`;
    let token = localStorage.getItem('auth');

    return await axios.delete(url, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },

  fetchTimeEvent: async (eventId, data, serviceId) => {
    let url = `${process.env.REACT_APP_API_URL}/eventReservation/fetchTimeEvent/${eventId}/${data}/${serviceId}`;

    return await axios.get(url, {
      headers: { Authorization: `Bearer ${auth.token}` },
    });
  },
};
